import { DROPDOWN_SEARCH_FIELD_KEY } from './finders/finder.component';

const DOCUMENT_BODY_ACTIVE_CLASS = 'sliding-menu--open';
const DROPDOWN_ACTIVE_CLASS = 'open';
const LINK_ACTIVE_CLASS = 'active';
const COLUMN_ACTIVE_CLASS = 'active';

const CLICK_EVENT_KEY = 'click.sliding-menu';
const KEYUP_EVENT_KEY = 'keyup.sliding-menu';

const KEYCODE_ESC = 'Escape';

export default class SlidingMenuComponent {
  /**
   * @param {JQuery | HTMLElement | string } links Links with `href` attribute corresponding to dropdown menu columns
   * @param {JQuery | HTMLElement | string } dropdown Dropdown element, containing columns that `links` refer to
   * @param {JQuery | HTMLElement | string } closeBtn Button (in dropdown element) that closes the dropdown on click
   */
  constructor(links, dropdown, closeBtn = '.close-btn', clearBtn = '.clear-btn') {
    /** @type JQuery<HTMLAnchorElement> */
    this.links = jQuery(links);

    /** @type JQuery<HTMLElement> */
    this.dropdown = jQuery(dropdown);

    /** @type JQuery<HTMLButtonElement> */
    this.closeBtn = this.dropdown.find(closeBtn);

    /** @type JQuery<HTMLButtonElement> */
    this.clearBtn = this.dropdown.find(clearBtn);

    this.closeClickHandler = this.closeClickHandler.bind(this);
    this.linkClickHandler = this.linkClickHandler.bind(this);
    this.clearClickHandler = this.clearClickHandler.bind(this);
  }

  get isOpen() {
    return this.dropdown.hasClass(DROPDOWN_ACTIVE_CLASS);
  }

  init() {
    this.links.off(CLICK_EVENT_KEY).on(CLICK_EVENT_KEY, this.linkClickHandler);
    this.closeBtn.off(CLICK_EVENT_KEY).on(CLICK_EVENT_KEY, this.closeClickHandler);
    this.dropdown.off(CLICK_EVENT_KEY).on(CLICK_EVENT_KEY, (e) => {
      e.stopPropagation();
    });

    this.clearBtn.on(CLICK_EVENT_KEY, this.clearClickHandler);

    return this;
  }

  /**
   *
   * @param {JQuery.ClickEvent<HTMLButtonElement>} event
   */
  linkClickHandler(event) {
    event.preventDefault();
    event.stopPropagation();

    const { currentTarget } = event;
    const href = currentTarget.getAttribute('href');

    if (!href) {
      return;
    }

    this.open(currentTarget);

    jQuery(document)
      .off(KEYUP_EVENT_KEY)
      .on(KEYUP_EVENT_KEY, (e) => {
        if (e.key === KEYCODE_ESC && this.isOpen === true) {
          this.closeClickHandler(e);
          jQuery(document).off(KEYUP_EVENT_KEY);
        }
      });

    jQuery(document)
      .off(CLICK_EVENT_KEY)
      .on(CLICK_EVENT_KEY, () => {
        this.closeClickHandler();
        jQuery(document).off(CLICK_EVENT_KEY);
      });
  }

  open(link) {
    const href = link.getAttribute('href');
    const dropdownFocusableItems = this.dropdown
      .addClass(DROPDOWN_ACTIVE_CLASS)
      .find(href)
      .addClass(COLUMN_ACTIVE_CLASS)
      .find('input, a, button');
    const focusableInputs = dropdownFocusableItems.filter('input');
    const focusableLinks = dropdownFocusableItems.filter('a, button');

    jQuery(document.body).addClass(DOCUMENT_BODY_ACTIVE_CLASS);
    this.links.removeClass(LINK_ACTIVE_CLASS).filter(link).addClass(LINK_ACTIVE_CLASS);

    setTimeout(() => {
      if (focusableInputs.length) {
        focusableInputs.eq(0).trigger('focus');
      } else if (focusableLinks.length) {
        focusableLinks.eq(0).trigger('focus');
      }
    }, 100);
  }

  /**
   *
   * @param {JQuery.ClickEvent<HTMLButtonElement>} event
   */
  closeClickHandler(event) {
    if (event) {
      event.preventDefault();
    }

    this.close();
  }

  close() {
    jQuery(document.body).removeClass(DOCUMENT_BODY_ACTIVE_CLASS);
    this.dropdown.removeClass(DROPDOWN_ACTIVE_CLASS);
    this.links.removeClass(LINK_ACTIVE_CLASS);
  }

  clearClickHandler(event) {
    if (event) {
      event.preventDefault();
    }

    this.clearInput();
  }

  clearInput() {
    this.dropdown.find(DROPDOWN_SEARCH_FIELD_KEY).val('').trigger('focus');
  }
}
